var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaderboardNavIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99966 10.2344H4.50273C3.67244 10.2344 3 10.9078 3 11.7371V19.4827C3 20.3099 3.67654 20.9864 4.50273 20.9864H19.4962C20.3235 20.9864 21 20.3099 21 19.4827V13.737C21 12.9077 20.3265 12.2343 19.4962 12.2343H15.0003",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9997 20.9848V5.48707C14.9997 4.65677 14.3262 3.98438 13.4969 3.98438H10.5027C9.67654 3.98438 9 4.66087 9 5.48707V20.9848",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboardNavIcon);
export default __webpack_public_path__ + "static/media/leaderboard_nav_icon.ff5386ec5ed3f8f2a75fd3d4de7b9663.svg";
export { ForwardRef as ReactComponent };